// add text "Public Use" on Sequence Generators link'
$(document).ready(  function() {
  $('#seqgenlinkvisitor').append("<span> : &nbsp;Public&nbsp;&nbsp;Use</span>");
  });
